import isNumber from 'lodash/isNumber';
import type { LoanTerm } from './types/LoanTerm';
import type { LoanTermRates } from './types/LoanTermRates';
import { loanTermArray } from './loanTermArray';

export const isLoanTermRates = (value: unknown): value is LoanTermRates => {
  if (typeof value !== 'object' || value === null) {
    return false;
  }

  const loanTerms = Object.keys(value) as LoanTerm[];

  if (loanTerms.length === 0) {
    return false;
  }

  const isInLoanTerms = (loanTerm: LoanTerm) => loanTerms.includes(loanTerm);

  if (!loanTermArray.every(isInLoanTerms)) {
    return false;
  }

  const isAPR = (loanTerm: LoanTerm) =>
    isNumber((value as LoanTermRates)[loanTerm]);

  return loanTerms.every(isAPR);
};
